// import { useWidgetContext } from '@/provider';
// import { Theme } from '@/styles';

// eslint-disable-next-line
export function useTheme(): Record<string, any> {
  // const { theme = {} } = useWidgetContext();
  // return theme;
  return {};
}
